// ==========================================================================
// components/MiniBars.tsx — small bar chart for Home widgets (FF-026)
// Plain divs, no chart library. Optional second series stacks on top.
// Hover a bar for its value.
// ==========================================================================
export default function MiniBars({ data, colour, colour2, unit, height = 120 }: {
  data: { label: string; value: number; value2?: number }[]; colour: string; colour2?: string; unit: string; height?: number;
}) {
  const max = Math.max(1, ...data.map((d) => d.value + (d.value2 ?? 0)));
  return (
    <div>
      <div className="flex items-end gap-1.5" style={{ height }}>
        {data.map((d, i) => {
          const h1 = (d.value / max) * (height - 4); const h2 = ((d.value2 ?? 0) / max) * (height - 4);
          return (
            <div key={i} className="group relative flex flex-1 flex-col justify-end" title={`${d.label}: ${Math.round(d.value)}${d.value2 !== undefined ? ` + ${Math.round(d.value2)}` : ""} ${unit}`}>
              {h2 > 0 && <div className="w-full rounded-t-sm" style={{ height: h2, background: colour2 }} />}
              <div className={`w-full ${h2 > 0 ? "" : "rounded-t-sm"}`} style={{ height: Math.max(d.value > 0 ? 2 : 0, h1), background: colour }} />
              {d.value + (d.value2 ?? 0) === 0 && <div className="h-0.5 w-full rounded-full bg-line" />}
            </div>
          );
        })}
      </div>
      <div className="mt-1.5 flex gap-1.5">{data.map((d, i) => <span key={i} className="flex-1 truncate text-center text-[10px] text-ink-muted">{d.label}</span>)}</div>
    </div>
  );
}
